/* Defender Safety custom script */

/* Helmet Simulator */
// Helmet simulator logo-item click
document.querySelectorAll(".helmet-simulator .logo-item").forEach((logoItem, index) => {
  logoItem.addEventListener("click", function () {
    // Switch cases based on the index
    document.querySelectorAll(".helmet-model").forEach((el) => el.classList.remove("active"));

    switch (index) {
      case 1:
        document.querySelector(".white-helmet")?.classList.add("active");
        break;
      case 2:
        document.querySelector(".yellow-helmet")?.classList.add("active");
        break;
      case 3:
        document.querySelector(".white-helmet")?.classList.add("active");
        break;
      case 4:
        document.querySelector(".purple-helmet")?.classList.add("active");
        break;
      case 5:
        document.querySelector(".white-helmet")?.classList.add("active");
        break;
    }

    // Update active class for logo items
    document.querySelectorAll(".helmet-simulator .logo-item").forEach((el) => el.classList.remove("active"));
    this.classList.add("active");

    // Update active class for print items
    document.querySelectorAll(".helmet-simulator .print-item").forEach((el) => el.classList.remove("active"));
    const printItem = document.querySelector(`.helmet-simulator .print-item:nth-child(${index + 1})`);
    if (printItem) {
      printItem.classList.add("active");
    }
  });
});

// Type toggle click
document.querySelectorAll(".type-toggle").forEach((typeToggle) => {
  typeToggle.addEventListener("click", function () {
    this.closest(".type-class")
      .querySelectorAll(".type-toggle")
      .forEach((el) => el.classList.remove("active"));
    this.classList.add("active");
  });
});

// H2-CE click
document.getElementById("h2-ce")?.addEventListener("click", function () {
  this.closest(".type-container")
    .querySelectorAll(".type-info")
    .forEach((el) => el.classList.remove("active"));
  document.getElementById("h2-ce-info")?.classList.add("active");
});

// H2-CC click
document.getElementById("h2-cc")?.addEventListener("click", function () {
  this.closest(".type-container")
    .querySelectorAll(".type-info")
    .forEach((el) => el.classList.remove("active"));
  document.getElementById("h2-cc-info")?.classList.add("active");
});

// H1-CE click
document.getElementById("h1-ce")?.addEventListener("click", function () {
  this.closest(".type-container")
    .querySelectorAll(".type-info")
    .forEach((el) => el.classList.remove("active"));
  document.getElementById("h1-ce-info")?.classList.add("active");
});

// H1-CC click
document.getElementById("h1-cc")?.addEventListener("click", function () {
  this.closest(".type-container")
    .querySelectorAll(".type-info")
    .forEach((el) => el.classList.remove("active"));
  document.getElementById("h1-cc-info")?.classList.add("active");
});

// Toggle button click
document.querySelectorAll(".toggle-button").forEach((toggleButton) => {
  toggleButton.addEventListener("click", function (e) {
    e.preventDefault();
    this.closest(".type-container")
      .querySelectorAll(".type-info")
      .forEach((el) => el.classList.toggle("active"));
    this.closest(".type-container")
      .querySelectorAll(".type-toggle")
      .forEach((el) => el.classList.toggle("active"));
  });

});
